import React, { Fragment } from "react";
import "../../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import apiEndPoint from "../../../utils/apiEndPoint";
import { apiCall } from "../../../utils/httpClient";
import { isEmpty } from "utils/utils";
import { Button, Form } from "react-bootstrap";

function TeamMembers(props) {
    const { setData, data, languageData, handleResetData } = props;

    const addNewEntery = () => {
        let newOdj = {
            status: '',
            name: '',
            designation: '',
            description: '',
            image: '',
        };
        let portForm = { ...data }
        let protItem = [...portForm.items, newOdj]
        portForm['items'] = protItem
        setData({ ...portForm });
    };

    const removeEntery = (index) => {
        let newArr = { ...data };
        let protItem = newArr.items;
        if (protItem.length > 1) {
            protItem.splice(index, 1);
        }
        newArr['items'] = protItem
        setData(newArr);
    };

    const handleInputValue = (index, name, value) => {
        let newArr = { ...data };
        let arr = [...newArr.items]
        arr[index][name] = value
        setData({ ...data, items: arr })
    }

    async function selectImageProt(index, files) {
        const formData = new FormData();
        formData.append("images", files[0]);
        const headers = { "Content-Type": "application/x-www-form-urlencoded" };
        const { data: result } = await apiCall('post', apiEndPoint.ORDERIMAGEUPLOAD, formData, headers);
        console.log('result 744444: ', result);

        if (result.status === 200) {
            let newArr = { ...data };
            let arr = [...newArr.items]
            arr[index]['image'] = result.data.base_url + result.data.images
            setData({ ...data, items: arr })
        }
    }
    const handleToggle = (e) => {
        e.stopPropagation(); // Prevent the Accordion from toggling
        setData({
            ...data,
            status: !data?.status
        });
    };
    return (
        <Fragment>
            <Accordion.Header>
                <div className="drop_header_dflex">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src="/assets/images/icon/team.png" alt="Team Members" width={'11%'} /> {" "}
                        <span style={{ marginLeft: '15px' }}>{languageData?.teamMembers}</span>
                    </div>
                    <Form.Check
                        defaultChecked={data?.status}
                        style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
                        type="switch"
                        className="custom-switch"
                        onChange={handleToggle}
                        onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                    />
                </div>
            </Accordion.Header>
            {data &&
                <Accordion.Body>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="input-field-box">
                                <div className="heading_lable_box">
                                    <label className="forn_title">{languageData?.heading}:</label>
                                    {/* <label className="thm_switch__btn input_swich_btn">
                                        <input className="thm_switch_input" type="checkbox" onChange={(e) => setData({ ...data, headingTitle: { ...data.headingTitle, status: data.headingTitle.status === true ? false : true } })} checked={data.headingTitle.status} />
                                        <span className="thm_switch_slider round"></span>
                                    </label> */}
                                </div>
                                <input
                                    placeholder="Enter Title ..."
                                    className="form-control"
                                    name='title'
                                    // onChange={(e)=>(setFormDetail({...formDetail, dataSection : {...}}))}
                                    value={data.headingTitle.value}
                                    onChange={(e) => setData({ ...data, headingTitle: { ...data.headingTitle, value: e.target.value } })}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="input-field-box">
                                <div className="heading_lable_box">
                                    <label className="forn_title">{languageData?.description}:</label>
                                    {/* <label className="thm_switch__btn input_swich_btn">
                                        <input className="thm_switch_input" type="checkbox" onChange={(e) => setData({ ...data, description: { ...data.description, status: data.description.status === true ? false : true } })} checked={data.description.status} />
                                        <span className="thm_switch_slider round"></span>
                                    </label> */}
                                </div>
                                <textarea
                                    placeholder="Description ..."
                                    className="form-control pb-5"
                                    value={data.description.value}
                                    onChange={(e) => setData({ ...data, description: { ...data.description, value: e.target.value } })}
                                />
                            </div>
                        </div>
                    </div>

                    {data.items && data.items.length > 0 && data.items.map((item, index) => (
                        <div key={index}>
                            <div className="row new_fild_shadow" style={{ background: '#f8f8ee', borderRadius: 10 }}>
                                {index > 0 && (
                                    <>
                                        {/* <div className="sav-proj-btn">
                                            <label className="thm_switch__btn card_input_swich_btn">
                                                <input className="thm_switch_input" type="checkbox" onChange={(e) => handleInputValue(index, 'status', item.status === true ? false : true)} checked={item.status} />
                                                <span className="thm_switch_slider round"></span>
                                            </label>

                                            <button
                                                className="cancel-btn"
                                                onClick={() => removeEntery(index)}
                                                type="button"
                                            >
                                                <i className="fa fa-times" aria-hidden="true"></i>
                                            </button>
                                        </div> */}
                                        <div className="sav-proj-btn">
                                            <Button
                                                style={{ borderRadius: 50, fontSize: 10, background: '#ff966a', border: 0, color: '#000', fontWeight: 400, float: 'right' }}
                                                onClick={() => removeEntery(index)}>
                                                <i className="fa fa-times" aria-hidden="true"></i>
                                            </Button>
                                        </div>
                                    </>
                                )}
                                <div className="col-lg-6">
                                    <div className="input-field-box">
                                        <label className="forn_title">{languageData?.name}:</label>
                                        <input
                                            placeholder="Enter name ..."
                                            className="form-control"
                                            name='name'
                                            value={item.name}
                                            onChange={(e) => handleInputValue(index, e.target.name, e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="input-field-box">
                                        <label className="forn_title">{languageData?.designation}:</label>
                                        <input
                                            placeholder="Designation"
                                            className="form-control"
                                            value={item.designation}
                                            name='designation'
                                            onChange={(e) => handleInputValue(index, e.target.name, e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="input-field-box">
                                        <label className="forn_title">{languageData?.description}:</label>
                                        <textarea
                                            placeholder="Description ..."
                                            className="form-control pb-5"
                                            value={item.description}
                                            name='description'
                                            onChange={(e) => handleInputValue(index, e.target.name, e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="input-field-box">
                                        <label className="forn_title">{languageData?.image}:</label>
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: '60%', padding: '1rem' }}>
                                                <input
                                                    placeholder="+ Upload image"
                                                    type="file"
                                                    className="form-control"
                                                    style={{ display: 'none' }}
                                                    id={`teamImage_${index}`}
                                                    onChange={(e) => selectImageProt(index, e.target.files)}
                                                    accept="image/png, image/jpg, image/jpeg"
                                                />
                                                <a className="select_profile_btn" htmlFor="exampleInputFile" onClick={() => document.getElementById(`teamImage_${index}`).click()} >{languageData?.selectImage}</a>
                                            </div>
                                            <div style={{ maxWidth: '70px' }}>
                                                {!isEmpty(item.image) && <>
                                                    <img src={item.image} alt={item.image} width={'100%'} />
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {index === data.items.length - 1 && (
                                <div className="sav-proj-btn">
                                    {/* <button
                                        className="sub-btn"
                                        onClick={addNewEntery}
                                        type="button"
                                    >
                                        {languageData?.addMore}
                                    </button> */}
                                    <Button
                                        onClick={addNewEntery}
                                        style={{ borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500 }}
                                        size='md'
                                    >
                                        {languageData?.addMore}
                                    </Button>
                                    <Button
                                        style={{ borderRadius: 50, width: 100, fontSize: 12, background: '#ff966a', color: '#000', fontWeight: 500, marginLeft: 20 }}
                                        size='md' onClick={() => handleResetData('team_members')}
                                    >
                                        {languageData?.reset}
                                    </Button>
                                </div>
                            )}
                        </div>
                    ))}
                </Accordion.Body>
            }
        </Fragment>
    );
}
export default TeamMembers;
